module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', {
    staticClass: "static-info--heading"
  }, [_vm._v("sk club and Movie Cards")]), _vm._v(" "), _c('h3', [_vm._v("Get the most out of all ster-kinekor movie benefits")])]), _vm._v(" "), _vm._l((_vm.article), function(article) {
    return _c('div', [_c('sk-panel', [_c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('h2', {
      staticClass: "static-info--sub-heading",
      domProps: {
        "innerHTML": _vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_1.heading)
      }
    })])], 1), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "md4": ""
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (article.Movie_Cards.Club_and_Movie_Cards.section_1.image.url),
        expression: "article.Movie_Cards.Club_and_Movie_Cards.section_1.image.url"
      }],
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": article.Movie_Cards.Club_and_Movie_Cards.section_1.image.url
      }
    })])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": "",
        "md8": ""
      }
    }, [_c('div', {
      staticClass: "club-movie-cards"
    }, [_c('div', {
      staticClass: "article__content",
      domProps: {
        "innerHTML": _vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_1.body)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "club-movie-cards__buttons"
    }, [_c('sk-button', {
      attrs: {
        "tertiary": "",
        "router": "",
        "to": {
          name: 'SK Club & loyalty Info',
          params: {
            card_name: 'SK_Club'
          }
        }
      }
    }, [_vm._v(_vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_1.button_text))]), _vm._v(" "), (_vm.isGuest) ? _c('sk-button', {
      attrs: {
        "primary": "",
        "router": "",
        "to": {
          name: 'user',
          params: {
            signInType: 'signup'
          }
        }
      }
    }, [_vm._v(_vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_1.additional_button_text))]) : (_vm.user.MemberLevelId == '19') ? _c('sk-button', {
      attrs: {
        "primary": "",
        "router": "",
        "to": "/user/profile#join"
      }
    }, [_vm._v(_vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_1.additional_button_text))]) : _c('sk-button', {
      attrs: {
        "primary": "",
        "router": "",
        "to": {
          name: 'profile'
        }
      }
    }, [_vm._v("Dashboard")]), _vm._v(" "), _c('sk-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isGuest),
        expression: "!isGuest"
      }],
      attrs: {
        "primary": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.resendVerification(_vm.CardNumber);
        }
      }
    }, [_vm._v("\n                                        Send Activation link\n                                    ")])], 1)])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs6": "",
        "md4": ""
      }
    }, [_c('div', {
      staticClass: "movie-card"
    }, [_c('h4', [_vm._v("\n                                 Kids\n                              ")]), _vm._v(" "), _c('div', {
      staticClass: "movie-card--image"
    }, [_c('img', {
      attrs: {
        "src": "/static/img/sk-club/kids.png",
        "alt": "Kids"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "movie-card--description"
    }, [_vm._v("\n                                  Enjoy a bespoke birthday party experience at any Ster-Kinekor Theatre. "), _c('a', {
      attrs: {
        "href": "mailto:leads@sterkinekor.com"
      }
    }, [_vm._v("Enquire here")])])])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": "",
        "md4": ""
      }
    }, [_c('div', {
      staticClass: "movie-card"
    }, [_c('h4', [_vm._v("\n                                 OVER 60\n                              ")]), _vm._v(" "), _c('div', {
      staticClass: "movie-card--image"
    }, [_c('img', {
      attrs: {
        "src": "/static/img/sk-club/over-60.png",
        "alt": "Over 60"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "movie-card--description"
    }, [_vm._v("\n                                Seniors enjoy 22% discount on all ticket types except Tuesday for Half Price Tuesdays. Seniors also receive access to exclusive SK CLUB screenings and the SK Club Lounge.\n                              ")])])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": "",
        "md4": ""
      }
    }, [_c('div', {
      staticClass: "movie-card"
    }, [_c('h4', [_vm._v("\n                                 VIP\n                              ")]), _vm._v(" "), _c('div', {
      staticClass: "movie-card--image"
    }, [_c('img', {
      attrs: {
        "src": "/static/img/sk-club/vip.png",
        "alt": "VIP"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "movie-card--description"
    }, [_vm._v("\n                                As an SK Club VIP member you get to enjoy exclusive SK CLUB screenings & events, as well as exclusive advanced bookings.\n                              ")])])])], 1)], 1), _vm._v(" "), _c('sk-panel', [_c('h2', [_vm._v("SK SUBSCRIPTION CLUB")]), _vm._v(" "), _c('sk-layout', {
      staticClass: "subs-club-header",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/img/subs/subs-club-cards.png",
        "alt": ""
      }
    })])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('div', {
      staticClass: "club-movie-cards"
    }, [_c('div', {
      staticClass: "article__content"
    }, [_c('p', [_vm._v("Watch more movies, for less!")]), _vm._v(" "), _c('p', [_vm._v("\n                                        As a SK Subscription Club member, you can get a subscription for a Limited or Unlimited \n                                        amount of movies per month at a set cost, which you pay per month. This means \n                                        you can now watch more movies at a lower price, whilst also enjoying the benefits \n                                        of the SK Club\n                                    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('sk-button', {
      attrs: {
        "primary": "",
        "tag": "a",
        "href": "/subscription-club"
      }
    }, [_vm._v("VIEW PRICING OPTIONS")])], 1)])])], 1)], 1), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "md4": ""
      }
    }, [_c('sk-panel', [_c('div', {
      staticClass: "club-movie-cards"
    }, [_c('h3', {
      staticClass: "club-movie-cards__heading",
      domProps: {
        "innerHTML": _vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_2.heading)
      }
    }), _vm._v(" "), (article.Movie_Cards.Club_and_Movie_Cards.section_2.image.url) ? _c('div', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": "/static/img/digital-discovery-card.png"
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "club-movie-cards__wrapper"
    }, [_c('div', {
      staticClass: "article__content",
      domProps: {
        "innerHTML": _vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_2.body)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "club-movie-cards__buttons"
    }, [_c('sk-button', {
      attrs: {
        "tertiary": "",
        "router": "",
        "to": {
          name: 'SK Club & loyalty Info',
          params: {
            card_name: 'Discovery_Vitality'
          }
        }
      }
    }, [_vm._v(_vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_2.button_text))])], 1)])])], 1), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": "",
        "md4": ""
      }
    }, [_c('sk-panel', [_c('div', {
      staticClass: "club-movie-cards"
    }, [_c('h3', {
      staticClass: "club-movie-cards__heading",
      domProps: {
        "innerHTML": _vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_3.heading)
      }
    }), _vm._v(" "), (article.Movie_Cards.Club_and_Movie_Cards.section_3.image.url) ? _c('div', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": article.Movie_Cards.Club_and_Movie_Cards.section_3.image.url
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "club-movie-cards__wrapper"
    }, [_c('div', {
      staticClass: "article__content",
      domProps: {
        "innerHTML": _vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_3.body)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "club-movie-cards__buttons"
    }, [_c('sk-button', {
      attrs: {
        "tertiary": "",
        "router": "",
        "to": {
          name: 'SK Club & loyalty Info',
          params: {
            card_name: 'Edgars_Club'
          }
        }
      }
    }, [_vm._v(_vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_3.button_text))])], 1)])])], 1), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": "",
        "md4": ""
      }
    }, [_c('sk-panel', [_c('div', {
      staticClass: "club-movie-cards"
    }, [_c('h3', {
      staticClass: "club-movie-cards__heading",
      domProps: {
        "innerHTML": _vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_4.heading)
      }
    }), _vm._v(" "), (article.Movie_Cards.Club_and_Movie_Cards.section_4.image.url) ? _c('div', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": article.Movie_Cards.Club_and_Movie_Cards.section_4.image.url
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "club-movie-cards__wrapper"
    }, [_c('div', {
      staticClass: "article__content",
      domProps: {
        "innerHTML": _vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_4.body)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "club-movie-cards__buttons"
    }, [_c('sk-button', {
      attrs: {
        "tertiary": "",
        "tag": "a",
        "href": article.Movie_Cards.Club_and_Movie_Cards.section_4.button_link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_4.button_text))])], 1)])])], 1)], 1)], 1)
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c03f0de","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/club-loyalty/club-loyalty.vue
// module id = 611
// module chunks = 0